import React from 'react';
import { Button, Modal, Typography } from '@attentive-platform/stem-ui';

import { ConfirmModalStyles as S } from './styles';

const ConfirmModal = ({
  open,
  title,
  body,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmVariant = 'primary',
  onConfirm,
  onCancel
}) => (
  <Modal
    show={open}
    onClose={onCancel}
    heading={<span className='pl-4'>{title}</span>}
    content={
      <S.ContentWrap>
        {body && (
          <Typography variant='body2' color='#4D4D4D' sx={{ lineHeight: 1.55 }}>
            {body}
          </Typography>
        )}
        <S.Actions>
          <Button variant='text' color='primary' size='large' onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button
            variant='contained'
            color={confirmVariant === 'error' ? 'error' : 'primary'}
            size='large'
            onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </S.Actions>
      </S.ContentWrap>
    }
  />
);

export default ConfirmModal;
